/**
 * Maps Level 2 platform names to their parent platform and appropriate tab.
 *
 * Level 2 platforms are sub-platforms or integrations that should navigate
 * to their parent platform page with a specific tab selected.
 *
 * @param platformName - The full platform name (e.g., "SkyTab Marketplace Integrations")
 * @returns Object with parent platform name and tab ID
 *
 * @example
 * mapToParentPlatform('SkyTab Marketplace Integrations')
 * // Returns: { platform: 'SkyTab', tab: 'level2-skytab-marketplace-integrations' }
 */
export const mapToParentPlatform = (platformName: string): { platform: string; tab: string } => {
  const lowerName = platformName.toLowerCase();

  // SkyTab Level 2 platforms
  if (lowerName.includes('skytab marketplace')) {
    return { platform: 'SkyTab', tab: 'level2-skytab-marketplace-integrations' };
  }
  if (lowerName.includes('skytab venue')) {
    return { platform: 'SkyTab Venue', tab: 'product-modules' };
  }

  // Default: use the platform name as-is (for Level 1 platforms)
  return { platform: platformName, tab: 'product-modules' };
};
